<template>
    <panel-template>
        <template #bradcrumbs>
            <ui-breadcrumbs design="full" :container="false">
                <template #left> Vendas &#8226; Configurações &#8226; Gerador de Documentos e Contratos </template>
            </ui-breadcrumbs>
        </template>

        <template #content>
            <router-view />
        </template>
    </panel-template>
</template>

<script>
	import { uiBreadcrumbs } from '@/components/ui'
	import PanelTemplate from '@/templates/page-panel-center'

	export default {
		name: 'sales-settings',

		components: {
			PanelTemplate,
			uiBreadcrumbs,
		},
	}
</script>
